import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import AppointmentsProvider from "../Appointments/AppointmentsProvider/AppointmentsProvider";
import CalendarMainView from "./CalendarMainView";
import ClassList from "./CalendarItemsList/ClassList";
import CalendarDetailPage from "./CalendarDetail";
import EventList from "./CalendarItemsList/EventList";
import ClassTypesList from "./ClassTypesList/ClassTypesList";
import { CalendarProvider } from "./CalendarProvider/CalendarProvider";

const CalendarRouter = () => {
  const { path } = useRouteMatch("/schedule");

  return (
    <AppointmentsProvider>
      <CalendarProvider>
        <Switch>
          <Route path={`${path}/classes`} component={ClassList} />
          <Route path={`${path}/class-types`} component={ClassTypesList} />
          <Route path={`${path}/events`} component={EventList} />
          <Route path={`${path}/cal:uuid`} component={CalendarDetailPage} />
          <Route path={`${path}`} component={CalendarMainView} />
        </Switch>
      </CalendarProvider>
    </AppointmentsProvider>
  );
};

export default CalendarRouter;
